import React from "react";
import { BookOpen, Mic, ImageIcon, Edit, ArrowRight, Book, FileText } from "lucide-react";
import Header from "./Header";
import { useNavigate } from "react-router-dom";
import backgroundImageBlur from "@assets/images/Select-amico1.png";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedModule } from "@/store/slices/studentDashboard";


const StudentDashboardCards = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user, role } = useSelector((state) => state.studentAuth);

  const handleClick = (id) => {
    if (id === 'TTT') {
      dispatch(setSelectedModule('TT'));
      navigate(`/${role === 'REVIEWER' ? 'reviewer' : 'student'}/lots-for-TTT`);
      return;
    } else if (id === 'ASR_TTS') {
      dispatch(setSelectedModule('TS'));
      navigate(`/${role === 'REVIEWER' ? 'reviewer' : 'student'}/lots-for-TTS`);
      return;
    }
    else if (id === 'dictionary') {
      dispatch(setSelectedModule('dictionary'));
      navigate(`/${role === 'REVIEWER' ? 'reviewer' : 'student'}/lots-for-Dictionary`);
      return;
    }
    navigate(`/${role === 'REVIEWER' ? 'reviewer' : 'student'}/` + id);
  };


  return (
    <div className="min-h-screen flex flex-col gap-4 items-center">
      <Header />
      {/* Welcome Message */}
      <div className="text-center">
        <p className="text-lg sm:text-xl font-['Semantic/Strong'] text-gray-800">
          🎉 Welcome, <span className="text-[#ec7026] font-semibold">{user}</span>!
          What would you like to work on today?
        </p>
      </div>

      {/* Cards Section */}
      <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-2 xl:grid-cols-2 gap-20 w-full max-w-7xl px-6 items-stretch">

        {/* Text to Text Translation */}
        <div
          className="bg-white h-[250px] rounded-2xl shadow-xl border border-gray-200 p-8 flex flex-col gap-4 hover:shadow-xl hover:scale-105 hover:border-[#ec7026] transition-all duration-300 ease-in-out hover:cursor-pointer"
          onClick={() => handleClick('TTT')}
        >
          <BookOpen className="text-[#ec7026] w-8 h-8" />
          <h3 className="text-[#ec7026] font-bold text-2xl font-['Semantic/Strong']">Text to Text Translation</h3>
          <p className="text-base text-gray-600 leading-relaxed">Convert a sentence from one Indian language to another using the Bharati Translation.</p>
          <div className="mt-auto flex justify-end"><ArrowRight className="text-[rgba(236,112,38,1)] hover:text-[rgba(236,112,38,1)] transition-all duration-200" /></div>
        </div>

        {/* ASR / TTS Translation */}
        <div
          className="bg-white h-[250px] rounded-xl shadow-xl border border-gray-200 p-8 flex flex-col gap-4 hover:shadow-2xl hover:scale-105 hover:border-[#ec7026] transition-all duration-300 ease-in-out hover:cursor-pointer"
          onClick={() => handleClick('ASR_TTS')}
        >
          <Mic className="text-[#ec7026] w-8 h-8" />
          <h3 className="text-[#ec7026] font-bold text-2xl font-['Semantic/Strong']">ASR / TTS Translation</h3>
          <p className="text-base text-gray-600 leading-relaxed">Transcribe speech or audio clips and translate them into your selected language.</p>
          <div className="mt-auto flex justify-end"><ArrowRight className="text-[rgba(236,112,38,1)] hover:text-[rgba(236,112,38,1)] transition-all duration-200" /></div>
        </div>

        {/* OCR Translation */}
        {/* <div
          className="bg-white h-[250px] rounded-xl shadow-xl border border-gray-200 p-8 flex flex-col gap-4 hover:shadow-2xl hover:scale-105 hover:border-[#ec7026] transition-all duration-300 ease-in-out hover:cursor-pointer"
          onClick={() => handleClick('OCR')}
        >
          <ImageIcon className="w-12 h-12 text-[#ec7026] stroke-[2.5]" />
          <h3 className="text-[#ec7026] font-bold text-2xl font-['Semantic/Strong']">OCR Translation</h3>
          <p className="text-base text-gray-600 leading-relaxed">
            Upload an image and extract the text for translation. Perfect for printed or handwritten content.
          </p>
          <div className="mt-auto flex justify-end">
            <ArrowRight className="text-[#ec7026] stroke-[2.5]" />
          </div>
        </div> */}

        {/* Dictionary */}
        <div
          className="bg-white h-[250px] rounded-xl shadow-xl border border-gray-200 p-8 flex flex-col gap-4 hover:shadow-2xl hover:scale-105 hover:border-[#ec7026] transition-all duration-300 ease-in-out hover:cursor-pointer"
          onClick={() => handleClick('dictionary')}
        >
          <Book className="w-12 h-12 text-[#ec7026] stroke-[2.5]" />
          <h3 className="text-[#ec7026] font-bold text-2xl font-['Semantic/Strong']">Dictionary</h3>
          <p className="text-base text-gray-600 leading-relaxed">
            Look up words, view meanings, synonyms, usage examples, and translations across Indian languages.
          </p>
          <div className="mt-auto flex justify-end">
            <ArrowRight className="text-[#ec7026] stroke-[2.5]" />
          </div>
        </div>

        {/* Monolingual Input */}
        {/* <div
          className="bg-white h-[250px] rounded-xl shadow-xl border border-gray-200 p-8 flex flex-col gap-4 hover:shadow-2xl hover:scale-105 hover:border-[#ec7026] transition-all duration-300 ease-in-out hover:cursor-pointer"
          onClick={() => handleClick('monolingual-input')}
        >
          <FileText className="w-12 h-12 text-[#ec7026] stroke-[2.5]" />
          <h3 className="text-[#ec7026] font-bold text-2xl font-['Semantic/Strong']">Monolingual Input</h3>
          <p className="text-base text-gray-600 leading-relaxed">
            Provide sentences in a single language to generate paraphrases, quality evaluation, or enrichment.
          </p>
          <div className="mt-auto flex justify-end">
            <ArrowRight className="text-[#ec7026] stroke-[2.5]" />
          </div>
        </div> */}


        {/* Decorative Image */}
        <div className="p-8 flex items-center justify-center h-[300px]">
          <img src={backgroundImageBlur} alt="img" className="h-50 object-contain" />
        </div>

      </div>
    </div>
  );
};

export default StudentDashboardCards;
